import { resolveImagePath } from '@/utils/imageResolver.ts';

export interface HeroProps {
  title: string;
  buttonText: string;
  buttonHref: string;
  backgroundImage: string;
  className?: string;
}

export function Hero({ 
  title, 
  buttonText, 
  buttonHref, 
  backgroundImage,
  className = '' 
}: HeroProps) {
  const bgImageUrl = resolveImagePath(backgroundImage);
  
  return (
    <div 
      className={`relative min-h-screen flex items-center justify-center text-center ${className}`}
      style={{
        backgroundImage: `linear-gradient(rgba(29, 29, 29, 0.5), rgba(29, 29, 29, 0.5)), url(${bgImageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 50%',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'scroll'
      }}
    >
      {/* Hero Content */}
      <div className="relative z-10 max-w-4xl px-4 py-20">
        <h1 
          className="text-white font-bold text-5xl md:text-6xl mb-8 leading-tight tracking-wider"
          style={{ 
            textTransform: 'uppercase',
            fontFamily: 'Poppins, "Poppins Fallback", sans-serif',
            lineHeight: '1.5',
            letterSpacing: '0.05em'
          }}
        >
          {title}
        </h1>
        
        <a
          href={buttonHref}
          className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-semibold text-lg rounded-md hover:from-yellow-500 hover:to-yellow-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span className="mr-3">
            <svg
              className="w-5 h-5 fill-current"
              viewBox="0 0 1024 1024"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3-12.3 12.7-12.1 32.9 0.6 45.3l183.7 179.1-43.4 252.9c-1.2 6.9-0.1 14.1 3.2 20.3 8.2 15.6 27.6 21.7 43.2 13.4L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.3-9.5-33.2-26.8-35.9z"/>
            </svg>
          </span>
          {buttonText}
        </a>
      </div>
    </div>
  );
}